<template>
    <v-layout align-center justify-center>
      <v-flex xs12>
        <v-layout class="display-3" mb-5 justify-center>TEK</v-layout>
        <v-card flat>
          <v-card-text>
            <v-form>
              <v-text-field prepend-icon="person"
                  v-model="email"
                  name="login"
                  label="Email"
                  type="text"
                  :error="!!errorMessages.length && 'email' in errorMessages"
                  :error-messages="dialogErrorMessage('email')"
                  required></v-text-field>
              <v-text-field prepend-icon="lock"
                  v-model="password"
                  name="password"
                  label="Parolă"
                  id="password"
                  type="password"
                  :error="!!errorMessages.length && 'password' in errorMessages"
                  :error-messages="dialogErrorMessage('password')"
                  required></v-text-field>
              <v-alert v-if="errorMessageGeneric" :value="true" type="error">{{ errorMessageGeneric }}</v-alert>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn block color="primary" @click="login()">Login</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
</template>

<script>
export default {
  data() {
    return {
      errorMessages: [],
      errorMessageGeneric: null,
      email: '',
      password: '',
      processing: false
    };
  },

  created() {
    this.$store.commit('CENTER_VIEW_VERTICAL', true);
  },

  methods: {
    login() {
      let loginData = { email: this.email, password: this.password };
      this.$store
        .dispatch('LOGIN', loginData)
        .then(response => {
          this.processing = false;
          this.$router.push({ name: 'Visits' });
        })
        .catch(error => {
          if (error.response.data.errors) {
            this.processing = false;
            this.errorMessages = error.response.data.errors;
          } else {
            this.processing = false;
            this.errorMessageGeneric = 'Email sau parolă incorectă';
          }
        });
    },

    dialogErrorMessage(field) {
      if (field in this.errorMessages) {
        return this.errorMessages[field];
      }
      return [];
    }
  }
};
</script>

<style>
  .logo-title {
    font-size: 70px;
  }
</style>